import React from 'react';
import { FadeIn, CTAButton, Section, SectionTitle, Accent } from './Shared';
import { ProductVideo } from './ProductVideo';
import { featuredTestimonials } from '../data/testimonials';
import { ShieldCheck, Lock, Wallet, Star, X, ArrowRightIcon, FileTextIcon, ZapIcon, LayersIcon, TrophyIcon } from 'lucide-react';
export const HERO_MOCKUP = 'https://cdn.magicpatterns.com/uploads/3HtKZw4asVmsKeZ33ozJrR/mockup_principal.png';
const PRODUCT_VIDEO = 'https://cdn.magicpatterns.com/uploads/uh2ZLnsgQQLg2bK31SdxgW/video%20libros.mp4';
export const Hero = () => {
  const chips = [{
    icon: FileTextIcon,
    label: '100% PDF'
  }, {
    icon: ZapIcon,
    label: 'Dostęp w 5 min'
  }, {
    icon: LayersIcon,
    label: '365 sesji'
  }];
  return <section className="relative overflow-hidden border-b border-white/5 bg-slate-950" data-id="element-293" data-mp="dyr8gbtil7b6">
      {/* Subtle top light — solid, not a gradient */}
      <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-sky-400/40" aria-hidden="true" data-id="element-294" data-mp="1pf7ref4a262s" />
      {/* minmax(0,1fr) keeps the mobile column exactly the screen width, even
          when content is wider — nothing gets pushed right. */}
      <div className="mx-auto grid w-full max-w-6xl grid-cols-[minmax(0,1fr)] items-center justify-items-center gap-3 px-5 pb-10 pt-5 sm:gap-6 sm:pt-8 md:px-8 md:pb-20 md:pt-14 lg:grid-cols-[minmax(0,1fr)_minmax(0,1.15fr)] lg:justify-items-stretch lg:gap-x-12 lg:gap-y-8" data-id="element-295" data-mp="1c94qhlgfj227">
        {/* Headline — fixed line breaks on mobile, fluid size so every line fits */}
        <FadeIn className="flex w-full min-w-0 flex-col items-center text-center lg:col-start-1 lg:row-start-1 lg:items-start lg:self-end lg:text-left" data-id="element-296" data-mp="tjonmrh9uxim">
          <p className="mb-2.5 flex items-center justify-center gap-2 text-[11px] font-semibold uppercase tracking-widest text-sky-400 sm:mb-4 sm:text-xs" data-id="element-297" data-mp="ojaipiayw3ot">
            <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-sky-400" aria-hidden="true" data-id="element-298" data-mp="fjneypurmlsl" />
            Trening Funkcjonalny 365™
          </p>
          {/* Italic glyphs lean right; a tiny right padding re-centers them optically */}
          <h1 className="w-full break-words pr-[0.06em] font-display text-[clamp(28px,8.4vw,42px)] font-black uppercase italic leading-[0.9] tracking-tight text-white sm:text-5xl sm:leading-[0.92] md:text-6xl lg:pr-0 lg:text-[50px] xl:text-[56px]" data-id="element-299" data-mp="10m8zn5ykv0x">
            <span className="block sm:inline" data-id="element-300" data-mp="3s5lzn0n0pps6">Zaplanuj cały</span>{' '}
            <span className="block sm:inline" data-id="element-301" data-mp="jp0w3zd5nowg">rok zajęć</span>{' '}
            <span className="block sm:inline" data-id="element-302" data-mp="jqu69omz8r97"><Accent data-id="element-303" data-mp="oodkwpnl761o">funkcjonalnych.</Accent></span>
            <span className="mt-1 block text-slate-400" data-id="element-304" data-mp="on2hiqy200b3">W 5 minut.</span>
          </h1>
          <p className="mx-auto mt-3 max-w-[330px] text-[15px] leading-snug text-slate-300 sm:mt-5 sm:max-w-md sm:text-base sm:leading-relaxed md:text-lg lg:mx-0" data-id="element-305" data-mp="9yeqmxz5kerh">
            365 gotowych sesji do poprowadzenia — niezależnie od tego, czy masz
            lata doświadczenia, czy dopiero zaczynasz.
          </p>
        </FadeIn>

        {/* Mockup */}
        <FadeIn delay={0.1} className="flex w-full min-w-0 justify-center lg:col-start-2 lg:row-span-2 lg:row-start-1" data-id="element-306" data-mp="2s4h9br76hi3x">
          <a href="#pricing" className="group block w-full" aria-label="Zobacz ofertę" data-id="element-307" data-mp="2n6fnwzma56pa">
            <img src={HERO_MOCKUP} alt="Trening Funkcjonalny 365 — 6 tomów, pakiet bonusów i dostęp cyfrowy na tablecie, komputerze i telefonie" width={1536} height={1024} loading="eager" decoding="async"
          // @ts-ignore fetchpriority is valid HTML
          fetchpriority="high" className="mx-auto block h-auto w-full max-w-[400px] object-contain sm:max-w-[560px] transition-transform duration-200 ease-out group-hover:-translate-y-1 lg:max-w-none" data-id="element-308" data-mp="31v21oww9dqee" />
          </a>
        </FadeIn>

        {/* CTA */}
        <FadeIn delay={0.15} className="flex w-full min-w-0 max-w-[420px] flex-col items-center sm:max-w-none lg:col-start-1 lg:row-start-2 lg:items-start lg:self-start" data-id="element-309" data-mp="3tkewq2h0lbxs">
          <ul className="mb-4 flex w-full flex-wrap items-center justify-center gap-1.5 sm:mb-5 sm:gap-2 lg:justify-start" data-id="element-310" data-mp="opfab722db99">
            {chips.map(({
            icon: Icon,
            label
          }) => <li key={label} className="inline-flex items-center gap-1 whitespace-nowrap rounded-full border border-white/10 bg-white/5 px-2.5 py-1 text-[11px] font-medium text-slate-200 sm:gap-1.5 sm:px-3 sm:py-1.5 sm:text-xs md:text-sm" data-id="element-311" data-mp="xpljwhun5r35">
                <Icon size={14} className="text-sky-400" aria-hidden="true" data-id="element-312" data-mp="17lyhhqtb4p36" />
                {label}
              </li>)}
          </ul>
          <CTAButton href="#pricing" className="w-full sm:w-auto" data-id="element-313" data-mp="1gh4lck90ox32">
            Zdobądź pełny pakiet
            <ArrowRightIcon size={18} className="transition-transform duration-200 group-hover/cta:translate-x-0.5" aria-hidden="true" data-id="element-314" data-mp="1ldux4vdsh6io" />
          </CTAButton>
          <div className="mt-3 flex w-full flex-wrap items-center justify-center gap-x-3 gap-y-1 text-center text-[11px] text-slate-400 sm:mt-4 sm:gap-x-4 sm:gap-y-1.5 sm:text-xs lg:justify-start" data-id="element-315" data-mp="1vddhve1iwwbs">
            <span className="flex items-center gap-1.5" data-id="element-316" data-mp="3awbfcp7vvlch">
              <ShieldCheck size={14} className="text-emerald-400" aria-hidden="true" data-id="element-317" data-mp="3auqk0xdqvydk" /> 7 dni gwarancji
            </span>
            <span className="flex items-center gap-1.5" data-id="element-318" data-mp="35z1qbaoepbp6">
              <Lock size={14} aria-hidden="true" data-id="element-319" data-mp="30z6wozd8y80f" /> Bezpieczna płatność
            </span>
            <span className="flex items-center gap-1.5" data-id="element-320" data-mp="2grq01ac2n2p">
              <Wallet size={14} className="text-sky-400" aria-hidden="true" data-id="element-321" data-mp="2ickjqwne60k" /> Płacisz w złotówkach
            </span>
          </div>
        </FadeIn>
      </div>
    </section>;
};
export const SocialProof = () => {
  const stats = [{
    value: '+500',
    label: 'trenerów nam ufa'
  }, {
    value: '6',
    label: 'gotowych tomów'
  }, {
    value: '5',
    label: 'bonusów w pakiecie'
  }, {
    value: '4,9/5',
    label: 'średnia ocena',
    star: true
  }];
  return <div className="border-b border-white/5 bg-slate-900/40 px-5 py-8 md:px-8" data-id="element-322" data-mp="gfhjl6xy24mb">
      <dl className="mx-auto grid max-w-6xl grid-cols-2 gap-y-6 md:grid-cols-4" data-id="element-323" data-mp="2anv3xn0psexf">
        {stats.map((s, i) => <FadeIn key={s.label} delay={Math.min(i * 0.05, 0.2)} className={`text-center ${i % 2 === 1 ? 'border-l border-white/10' : ''} ${i > 0 ? 'md:border-l md:border-white/10' : ''}`} data-id="element-324" data-mp="2fm6ho8u4r9kx" data-mpi={i}>
            <dt className="sr-only" data-id="element-325" data-mp="25wmyf22i9dpj">{s.label}</dt>
            <dd className="font-display text-4xl font-black italic leading-none tracking-tight text-white md:text-5xl" data-id="element-326" data-mp="25v1zz1d2lame">
              {s.value}
            </dd>
            <dd className="mt-2 flex items-center justify-center gap-1 text-sm text-slate-400" data-id="element-327" data-mp="1w00c08uj6ele">
              {s.label}
              {s.star && <Star size={12} className="fill-amber-400 text-amber-400" aria-hidden="true" data-id="element-328" data-mp="1i1k7mok5506f" />}
            </dd>
          </FadeIn>)}
      </dl>
    </div>;
};
const Stars = ({
  size = 12
}: {
  size?: number;
}) => <div className="flex text-amber-400" role="img" aria-label="5 na 5 gwiazdek" data-id="element-329" data-mp="3hcjv5cgl51xb">
    {[...Array(5)].map((_, j) => <Star key={j} size={size} className="fill-current" aria-hidden="true" data-id="element-330" data-mp="15oosln3w1xv2" data-mpi={j} />)}
  </div>;
export const Testimonials1 = () => <Section className="bg-slate-950 !py-12 md:!py-16" data-id="element-331" data-mp="10rg7percvfq4">
    <div className="grid grid-cols-1 gap-4 md:grid-cols-3" data-id="element-332" data-mp="1ff1djgfm7t1q">
      {featuredTestimonials.map((t, i) => <FadeIn key={t.author} delay={Math.min(i * 0.05, 0.2)} data-id="element-333" data-mp="1aokwlmcl5pam" data-mpi={i}>
          <figure className="flex h-full flex-col rounded-2xl border border-white/10 bg-white/[0.03] p-5 md:p-6" data-id="element-334" data-mp="1am85ojouo4lf">
            <Stars data-id="element-335" data-mp="1ohivhio8lzix" />
            <blockquote className="mt-3 text-[15px] leading-relaxed text-slate-200" data-id="element-336" data-mp="1jh4om3ydgvmh">
              „{t.text}”
            </blockquote>
            <figcaption className="mt-auto flex items-center gap-3 pt-5" data-id="element-337" data-mp="1yckposxddrsd">
              <div className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full ${t.bg} text-xs font-bold text-white`} data-id="element-338" data-mp="1tej3hz4ndcco">
                {t.initials}
              </div>
              <div className="min-w-0" data-id="element-339" data-mp="3v6ff18qtem7g">
                <p className="text-sm font-semibold leading-tight text-white" data-id="element-340" data-mp="3v7gzg3tq0l1u">{t.author}</p>
                <p className="text-xs text-slate-500" data-id="element-341" data-mp="39c70mhfncbnv">{t.role}</p>
              </div>
            </figcaption>
          </figure>
        </FadeIn>)}
    </div>
  </Section>;
export { Stars };
export const Problem = () => {
  const painPoints = ['Wchodzisz na salę i nie wiesz dokładnie, jakie zajęcia dziś poprowadzisz', 'Spędzasz godziny na szukaniu ćwiczeń dopasowanych do grupy', 'Powtarzasz te same obwody, bo nie masz własnej bazy sesji', 'Przychodzi nowa osoba, a Ty nie wiesz, jak od ręki dopasować trening', 'Chcesz mieć roczny plan, ale brakuje Ci czasu, żeby go stworzyć', 'Twoja grupa stoi w miejscu, gdy tylko próbujesz wprowadzić realną progresję', 'Weekendy na szukaniu pomysłów. Poniedziałki na improwizacji. I tak w kółko.'];
  return <Section className="bg-slate-900/40" data-id="element-342" data-mp="fl1c5yvycrs0">
      <FadeIn data-id="element-343" data-mp="fo5mle00gjr4">
        <SectionTitle data-id="element-344" data-mp="jno8abznoyv0">
          Jeśli prowadzisz <Accent data-id="element-345" data-mp="jmmx87in4cda">trening funkcjonalny</Accent>,
          <br className="hidden md:block" data-id="element-346" data-mp="jpiudtmnyx0o" /> to zabrzmi znajomo…
        </SectionTitle>
      </FadeIn>

      <ul className="mx-auto mb-16 grid max-w-4xl grid-cols-1 gap-x-8 gap-y-1 md:mb-24 md:grid-cols-2" data-id="element-347" data-mp="247jkfprthzsg">
        {painPoints.map((point, i) => <li key={point} className={`flex items-start gap-3 border-b border-white/5 py-3.5 ${i === painPoints.length - 1 ? 'md:col-span-2 md:mx-auto md:max-w-md md:border-b-0' : ''}`} data-id="element-348" data-mp="1vcdd2mcwf9nt" data-mpi={i}>
            <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-red-500/15" data-id="element-349" data-mp="1lfhdj64z9xve">
              <X size={12} className="text-red-400" strokeWidth={3} aria-hidden="true" data-id="element-350" data-mp="1gf31ld09a3s3" />
            </span>
            <p className="text-[15px] leading-normal text-slate-300 md:text-base" data-id="element-351" data-mp="1cfc7azbit5it">{point}</p>
          </li>)}
      </ul>

      <FadeIn className="mx-auto mb-12 grid max-w-5xl items-center gap-6 md:mb-16 md:grid-cols-2 md:gap-12" data-id="element-352" data-mp="17hj2a9lyehk4">
        <h3 className="text-center font-display text-4xl font-black uppercase italic leading-[0.92] tracking-tight text-white md:text-left md:text-5xl" data-id="element-353" data-mp="36q7ogq0rtsx7">
          Wciąż <Accent data-id="element-354" data-mp="iabremrcagao">improwizujesz</Accent> treningi?
        </h3>
        <div className="space-y-4 text-center text-base leading-relaxed text-slate-300 md:text-left md:text-lg" data-id="element-355" data-mp="dctr1kre19ea">
          <p data-id="element-356" data-mp="rcl51lhwmpsa">
            Robisz to, bo kochasz trening funkcjonalny i lubisz patrzeć, jak
            Twoja grupa robi postępy.
          </p>
          <p data-id="element-357" data-mp="me1j3l3b9dzx">
            Niezależnie od tego, czy masz lata doświadczenia, czy dopiero
            zaczynasz, problem jest ten sam: więcej czasu{' '}
            <strong className="font-semibold text-white" data-id="element-358" data-mp="3qs9btjjkkqs0">SZUKASZ</strong>, co
            poprowadzić, niż faktycznie{' '}
            <strong className="font-semibold text-white" data-id="element-359" data-mp="8e8rlnjymtqw">PROWADZISZ</strong>{' '}
            zajęcia. A gdy Ty tracisz niedziele na układanie sesji, konkurencja
            ucieka do przodu.
          </p>
        </div>
      </FadeIn>

      <FadeIn className="mx-auto max-w-3xl" data-id="element-360" data-mp="3c0h7e2lbcx52">
        <div className="rounded-3xl border border-sky-400/40 bg-blue-600/10 px-6 py-8 text-center md:px-10 md:py-10" data-id="element-361" data-mp="3748xb3lz3u4r">
          <p className="font-display text-2xl font-black uppercase italic leading-[1.02] tracking-tight text-white md:text-4xl" data-id="element-362" data-mp="1mkn26nwvpq0v">
            A gdyby to były <Accent data-id="element-363" data-mp="1dkqiz1t9djd7">ostatnie zajęcia</Accent>
            <br data-id="element-364" data-mp="1dlt7x470tbqh" /> przygotowane w ten sposób?
          </p>
        </div>
      </FadeIn>

      <FadeIn className="mt-20 text-center md:mt-28" data-id="element-365" data-mp="1ij1tzfvahzx0">
        <p className="mb-5 inline-flex items-center gap-2 rounded-full bg-amber-400 px-3.5 py-1.5 text-xs font-bold uppercase tracking-wide text-amber-950" data-id="element-366" data-mp="1ihgxhkpf06wi">
          <TrophyIcon size={14} className="shrink-0" aria-hidden="true" data-id="element-367" data-mp="2a9zg2135im9i" />
          System nr 1 dla trenerów
        </p>
        <h2 className="font-display text-4xl font-black uppercase italic leading-[0.95] tracking-tight text-white md:text-6xl" data-id="element-368" data-mp="1wazux3eukpi3">
          Trening Funkcjonalny <Accent data-id="element-369" data-mp="kvjlm65jiztj">365™</Accent>
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-base leading-relaxed text-slate-300 md:text-lg" data-id="element-370" data-mp="kuhyv4f5wovz">
          6 tomów + 5 bonusów — 365 gotowych sesji · Cały rok · Wszystko
          gotowe.
        </p>

        <div className="relative mx-auto mt-10 max-w-3xl overflow-hidden rounded-3xl border border-white/10 bg-slate-900 shadow-2xl shadow-black/50" data-id="element-371" data-mp="5sjfx1acjms3">
          <ProductVideo src={PRODUCT_VIDEO} label="Podgląd tomów Trening Funkcjonalny 365" className="block w-full object-cover" data-id="element-372" data-mp="3t5lustsef2ad" />
        </div>
      </FadeIn>
    </Section>;
};